import instance from '../utils/interceptors';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Utility function to get token and set headers
const getHeaders = async (type = 0) => {
  const token = localStorage.getItem('token'); // Use localStorage in web
  return {
    Accept: type ? 'multipart/form-data' : 'application/json',
    'Content-Type': type ? 'multipart/form-data' : 'application/json',
    ...(token ? { Authorization: token } : {}),
  };
};

// Helper to handle errors and show toast
const handleError = (error) => {
  toast.error(error?.message || 'Something went wrong');
  return Promise.reject(error);
};

// POST request
export const post = async (url, formData, type = 0) => {
  const options = { headers: await getHeaders(type) };
  try {
    const response = await instance.post(url, formData, options);
    return response?.data;
  } catch (error) {
    return handleError(error);
  }
};

// PUT request
export const put = async (url, formData, type = 0) => {
  const options = { headers: await getHeaders(type) };
  try {
    const response = await instance.put(url, formData, options);
    return response?.data;
  } catch (error) {
    return handleError(error);
  }
};

// GET request
export const get = async (url) => {
  const options = { headers: await getHeaders() };
  try {
    const response = await instance.get(url, options);
    return response?.data;
  } catch (error) {
    return handleError(error);
  }
};

// DELETE request
export const deleteApi = async (url) => {
  const options = { headers: await getHeaders() };
  try {
    const response = await instance.delete(url, options);
    return response?.data;
  } catch (error) {
    return handleError(error);
  }
};
